export default __webpack_public_path__ + "static/media/Cl_k_q0Q.763d4075.jpg";